export const TAB_TYPES = {
  RESUMES: 0,
  COVERS: 1,
  BIO_DATA: 2,
  RESIGNATION_LETTERS: 3,
};

export const isResumesTab = (tabIndex) => tabIndex === TAB_TYPES.RESUMES;
export const isCoversTab = (tabIndex) => tabIndex === TAB_TYPES.COVERS;
export const isBioDataTab = (tabIndex) => tabIndex === TAB_TYPES.BIO_DATA;
export const isResignationLettersTab = (tabIndex) =>
  tabIndex === TAB_TYPES.RESIGNATION_LETTERS;

export const getCollectionContext = (tabIndex) => {
  switch (tabIndex) {
    case TAB_TYPES.RESUMES:
      return BUILDER_KEYS.builders;
    case TAB_TYPES.COVERS:
      return BUILDER_KEYS.covers;
    case TAB_TYPES.BIO_DATA:
      return BUILDER_KEYS.bioData;
    case TAB_TYPES.RESIGNATION_LETTERS:
      return BUILDER_KEYS.resignationLetters;
    default:
      return BUILDER_KEYS.builders;
  }
};
export const getStorageContext = (tabIndex) => {
  switch (tabIndex) {
    case TAB_TYPES.RESUMES:
      return BUILDER_KEYS.resumes;
    case TAB_TYPES.COVERS:
      return BUILDER_KEYS.covers;
    case TAB_TYPES.BIO_DATA:
      return BUILDER_KEYS.bioData;
    case TAB_TYPES.RESIGNATION_LETTERS:
      return BUILDER_KEYS.resignationLetters;
    default:
      return BUILDER_KEYS.resumes;
  }
};

export const BUILDER_KEYS = {
  builders: 'builders',
  covers: 'covers',
  bioData: 'bioData',
  resignationLetters: 'resignationLetters',
  resumes: 'resumes',
};

export const isBioDataContext = (context) => context === BUILDER_KEYS.bioData;
export const isCoverLetterContext = (context) =>
  context === BUILDER_KEYS.covers;
export const isResignationLetterContext = (context) =>
  context === BUILDER_KEYS.resignationLetters;